import { useEffect, useState } from 'react';
import { type UserPrefs, getPrefs } from './api';
import { useSession } from './use-session';

/**
 * Preferencje konta w komponencie.
 *
 * Wartości domyślne oddajemy **od razu**, przed odpowiedzią serwera, i to nie jest
 * optymalizacja: odtwarzacz pyta o nie w chwili startu odcinka, a czekanie na
 * żądanie znaczyłoby, że przez pierwsze pół sekundy automat pomijania jest
 * wyłączony niezależnie od ustawienia. Domyślne są zarazem zachowaniem sprzed
 * wprowadzenia preferencji, więc nikt nie zobaczy skoku.
 *
 * Bez sesji nie pytamy: gość nie ma konta, do którego dałoby się cokolwiek zapisać.
 */

const DEFAULTS: UserPrefs = {
  autoplayNext: false,
  autoSkipOpening: false,
  mediaTtlDays: null,
};

export function useUserPrefs(): UserPrefs {
  const { session } = useSession();
  const [prefs, setPrefs] = useState<UserPrefs>(DEFAULTS);

  const authenticated = session?.authenticated === true;

  useEffect(() => {
    if (!authenticated) {
      setPrefs(DEFAULTS);
      return;
    }
    let cancelled = false;
    getPrefs()
      .then((data) => {
        if (!cancelled) setPrefs(data);
      })
      .catch(() => {
        // Brak preferencji nie może zabrać odtwarzania — zostają domyślne.
      });
    return () => {
      cancelled = true;
    };
  }, [authenticated]);

  return prefs;
}
